type RouteItem = {
  label: string;
  href: string;
};

export const createRouteItem = (label: string, href: string): RouteItem => ({
  label,
  href,
});
